import BillingsOrderAddressesRequest from "../../../../api/raily/billings/order/addresses/billings-order-addresses.request";
import BillingsOrderAddressesParams from "./billings-order-addresses-params";

const create = (
  params: BillingsOrderAddressesParams,
): BillingsOrderAddressesRequest => {
  return {
    orderId: params.orderUuid,
    searchQuery: params.searchQuery,
  };
};

const billingsOrderAddressesParamsFactory = {
  create,
};

export default billingsOrderAddressesParamsFactory;
